// @core/api/endpoints/apikey/get_api_key_usage.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  APIKeyUsageResponse,
} from '../../../types/apikey';

const BASE_PATH = '/apikey';

/**
 * Get API key usage statistics
 * Returns aggregated usage statistics for an API key within a specified time period. Includes request counts, error rates, and latency metrics.
 */
export async function GetAPIKeyUsage(
  key_id: string,
  options?: RequestOptions
): Promise<APIKeyUsageResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/api-keys/:key_id/usage`;
  requestPath = requestPath.replace(':key_id', encodeURIComponent(key_id));
  const requestOptions = options;
  return client.get<APIKeyUsageResponse>(requestPath, { ...requestOptions });
}
